/**
 * Poziom konkursu
 *
 * @export
 * @enum {number}
 */
export enum SchoolLevel {
  ALL = 0,
  ELEMENTARY = 1,
  ABOVE_ELEMENTARY = 2
}

export const schoolLevelTranslation = {
  [SchoolLevel.ALL]: 'Wszystkie',
  [SchoolLevel.ELEMENTARY]: 'Podstawowy',
  [SchoolLevel.ABOVE_ELEMENTARY]: 'Ponadpodstawowy'
};

export const schoolLevelList = [
  { value: SchoolLevel[0], text: schoolLevelTranslation[SchoolLevel.ALL] },
  { value: SchoolLevel[1], text: schoolLevelTranslation[SchoolLevel.ELEMENTARY] },
  { value: SchoolLevel[2], text: schoolLevelTranslation[SchoolLevel.ABOVE_ELEMENTARY] }
];
